module.exports = __webpack_public_path__ + "img/chevron-up-light.c6641ae3.svg";